<div class="c-premiumPass__reward">
  <div
    class="e-background"
    theming
    themingGroup="premiumpass"
    themingAsset="reward-background"
    [themingOverride]="premiumPassRewardModalData?.properties?.assets">
    <slotcom-button
      class="c-button--pink"
      (safeClick)="closeModal()">
      {{ buttonText | uppercase }}
    </slotcom-button>
  </div>
</div>
